<script lang="ts">
  // @ts-ignore
  import { custom_event } from "svelte/internal";
  import { getContext, tick } from "svelte";
  import FieldContainer from "./FieldContainer.svelte";
  import { selectedKey, type Select } from "../fields/OptionGroup.svelte";

  export let title = "";
  export let value: string | object = "";
  export let key: (x: any) => string = (x) => x;
  export let closeOnTrigger: boolean;

  let ref: HTMLElement;
  const selected = getContext<SvelteStore<Select>>(selectedKey);

  async function handleInteraction() {
    if (!$selected.allowEmpty) {
      // If only one value can be selected at a time, set the array to the selected value
      $selected.selected = [value];
    } else {
      // If the value is already in the array, filter it out
      // Otherwise, add it to the array
      if ($selected.selected.some((item) => key(item) === key(value))) {
        $selected.selected = $selected.selected.filter((item: string) => key(item) !== key(value));
      } else {
        $selected.selected = [...$selected.selected, value];
      }
    }

    // It returns a promise that resolves as soon as any pending state changes have been applied to the DOM (or immediately, if there are no pending state changes).
    // We need to wait for the "selection" state to be updated before dispatching the event
    await tick();
    const event = custom_event("select", value, { bubbles: true });
    // dispatch a select event to the parent element, catched at the SelectGroup level

    // if (!ref) {
    //   return;
    // }
    ref.dispatchEvent(event);
  }
</script>

<FieldContainer {title} {closeOnTrigger}>
  <!-- additional on:click events can be forwarded to this element alongside handleInteraction -->
  <button
    type="button"
    class="ov-focus w-full after:rounded"
    on:click={handleInteraction}
    on:click
    on:keydown={(e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        handleInteraction();
      }
    }}
    bind:this={ref}
  >
    <slot />
  </button>
</FieldContainer>
